import React, { useState, memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Context from 'managers/Context';
import { getLiteral } from 'utils/getLiteral';
import PopoverMenu from 'components/PopoverMenu';

const LanguageSelector = memo(({ onChange, locale }) => {
    const userLangISO = useSelector((state) => state.config?.userData?.langISOInterface);
    const [languageOptions, setLanguageOptions] = useState([]);

    useEffect(() => {
        Context.serverListManager
            .getList('tblTiposIdioma')
            .then((languages) => {
                const options = languages.map((lang) => ({
                    value: lang.striso639_1.toLowerCase(),
                    label: lang.descripcion,
                }));
                setLanguageOptions(options);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [userLangISO]);

    const currentLanguage = useMemo(() => {
        if (!languageOptions?.length) return undefined;
        const selected = languageOptions.find((option) => option.value === (locale || userLangISO));
        return selected;
    }, [locale, languageOptions, userLangISO]);

    return (
        <PopoverMenu
            title={getLiteral('common_language')}
            advice={getLiteral('label_automations_value_list_language_desc')}
            options={languageOptions}
            onChange={onChange}
            value={currentLanguage}
        />
    );
});

LanguageSelector.displayName = 'LanguageSelector';

export default LanguageSelector;
